{
  "tabs": {
    "producers": "Producers",
    "beefOverview": "Beef Overview",
    "comparisons": "Comparisons",
    "benchMarking": "Benchmarking",
    "plantComparison": "Plant Comparison",
    "liveToCameraDashboard": "Live to Camera Dashboard"
  },
  "allLocations": "All Locations",
  "producers": {
    "producer": "Producer",
    "noFarmerNamesAssigned": "You do not have any farmer names assigned for this location. Please contact your administrator to assign farmer names to your account.",
    "avgWeight": "Avg Weight",
    "avgYieldGrade": "Avg Yield Grade",
    "avgUsdaMarbling": "Avg USDA Marbling",
    "totalCarcases": "Total Carcases",
    "averageOverSelectedPeriod": "Average over the selected date range",
    "averageOverLast12Months": "Average over last 12 months",
    "totalCarcasesInfo": "Total scanned carcases with YG records, by scan date, excludes missed scans.",
    "producerLabel": "Producer: {{name}}"
  },
  "filters": {
    "all": "All",
    "breed": "Breed",
    "sex": "Sex",
    "city": "City",
    "consignment": "Consignment",
    "age": "Age",
    "lotBatch": "Batch",
    "brand": "Brand",
    "allBrands": "All Brands",
    "all1953": "1953 All",
    "filters": "Filters",
    "editConsignmentName": "Edit Consignment Name",
    "consignmentName": "Consignment Name",
    "update": "Update",
    "clickToEditName": "Click to edit name"
  },
  "beefOverview": {
    "numberOfCarcases": "Number of Carcases",
    "numberOfCarcasses": "Number of Carcasses",
    "yieldGrade": "Yield Grade",
    "usdaMarbling": "USDA Marbling",
    "yieldGradeDistribution": "Yield Grade Distribution",
    "usdaMarblingDistribution": "USDA Marbling Distribution",
    "distribution": "{{trait}} Distribution",
    "vsChart": "{{xAxis}} vs {{yAxis}}",
    "copyBarcode": "Copy Barcode",
    "carcasses": "carcasses",
    "count": "Count",
    "percentage": "Percentage",
    "traitImagesTitle": "{{trait}} Images",
    "traitSelection": "{{trait}}: {{group}}"
  },
  "comparisons": {
    "producerPerformance": "Producer Performance: Yield Grade vs Marbling",
    "producerSummary": "Producer Summary",
    "yieldGradeDistributionComparison": "Yield Grade Distribution Comparison",
    "rank": "Rank",
    "yieldGradeDistribution": "Yield Grade Distribution",
    "averageMarblingScore": "Average Marbling Score",
    "averageSubcutFat": "Average Sub-cut Fat",
    "averageOverallYGScore": "Average Overall YG Score",
    "avgMarbling": "Avg Marbling",
    "avgSubcutFat": "Avg Sub-cut Fat",
    "producerName": "Producer name",
    "topTen": "Top 10",
    "bottomTen": "Bottom 10",
    "clearAll": "Clear All",
    "allProducersAverage": "All Producers Average",
    "percentageOfAnimals": "Percentage of Animals (%)",
    "farmerImagesTitle": "{{name}} Images"
  },
  "benchmarking": {
    "keyPerformanceMetrics": "Key Performance Metrics",
    "avg": "Avg",
    "usdaQualityGradeDistribution": "USDA Quality Grade Distribution",
    "qualityGrade": "Quality Grade",
    "percentageOfAnimals": "Percentage of Animals (%)",
    "yourData": "Your Data",
    "allProducers": "All Producers",
    "selectProducer": "Please select a producer to view data",
    "multiMetricComparison": "Multi-Metric Comparison",
    "percentileRanking": "Percentile Ranking",
    "yourPerformance": "Your Performance",
    "top10Percent": "Top 10%",
    "distributionComparison": "Distribution Comparison",
    "usdaMarblingDistribution": "USDA Marbling Distribution",
    "yieldGradeDistribution": "Yield Grade Distribution",
    "distributionPercent": "Distribution %",
    "performanceTrends": "Performance Trends (12 Months)",
    "usdaMarblingScoreOverTime": "USDA Marbling Score Over Time",
    "yieldGradeScoreOverTime": "Yield Grade Score Over Time",
    "producerAverage": "Producer Average",
    "marbling": "Marbling",
    "yieldGrade": "Yield Grade",
    "hotCarcassWeight": "Hot Carcass Weight",
    "hotCarcassWeightDistribution": "Hot Carcass Weight Distribution",
    "hotCarcassWeightOverTime": "Hot Carcass Weight Over Time",
    "yourAnimalDemographics": "Your Animal Demographics",
    "byBreed": "By Breed",
    "bySex": "By Sex",
    "metrics": {
      "usdaMarbling": "USDA Marbling",
      "yieldGrade": "Yield Grade",
      "hotCarcassWeight": "Hot Carcass Weight",
      "ribEyeArea": "Rib Eye Area",
      "backFat": "Back Fat",
      "selectPercent": "Select %",
      "primePercent": "Prime %",
      "choicePercent": "Choice %"
    },
    "vsProducerAverage": "Vs producer average",
    "nthPercentile": "{{value}} percentile",
    "month": "Month",
    "usdaMarblingScore": "USDA Marbling Score",
    "weightKg": "Weight (kg)",
    "selectMetric": "Select metric"
  },
  "plantComparison": {
    "title": "Plant Comparison",
    "allPlants": "All Plants",
    "metric": "Metric",
    "metrics": {
      "marbling": "USDA Marbling",
      "yieldGrade": "Yield Grade",
      "ema": "Rib Eye Area (cm²)",
      "ribFat": "Back Fat (mm)",
      "weight": "Hot Carcass Weight (kg)"
    },
    "views": {
      "trend": "Trend",
      "distribution": "Distribution"
    },
    "noDataToDisplay": "No data to display"
  },
  "imageGrid": {
    "title": "USDA Marbling × Yield Grade Image Grid",
    "images": "Images",
    "heatmap": "Heatmap",
    "avgVolumePercent": "Average Volume %",
    "avgWeight": "Average Weight",
    "avgRibEyeArea": "Average Rib Eye Area",
    "volumePercent": "Volume %",
    "noDataToDisplay": "No data to display",
    "noImage": "No Image",
    "usdaMarblingGrade": "USDA Marbling Grade"
  },
  "cellDetails": {
    "title": "Cell Details",
    "clickToView": "Click on a cell in the image grid to view detailed metrics and analytics for that YG × USDA Marbling combination.",
    "selectImage": "Select an image on the left to view it here",
    "ygGuide": "{{label}} Guide",
    "ygGuide1": "Highest retail yield, minimal external fat, largest rib eye area relative to carcass weight. Produces the highest percentage of valuable retail cuts with minimal fat trim needed.",
    "ygGuide2": "High retail yield with moderate external fat and good rib eye area. Produces a high percentage of retail cuts with minimal fat trim required.",
    "ygGuide3": "Average retail yield with moderate external fat and rib eye area. Standard retail cut percentage with moderate fat trim needed.",
    "ygGuide4": "Below-average retail yield with increased external fat and smaller rib eye area. Lower percentage of retail cuts with considerable fat trim required.",
    "ygGuide5": "Lowest retail yield, highest external fat, smallest rib eye area relative to carcass weight. Significant fat trim needed, resulting in the lowest percentage of valuable retail cuts.",
    "imagesCount": "{{count}} of {{total}} images",
    "overview": "Overview",
    "producers": "Producers",
    "cellMetrics": "Cell Metrics",
    "avgRibEyeArea": "Average Rib Eye Area:",
    "avgSubCutFat": "Average Sub Cut Fat:",
    "avgHSCW": "Average HSCW:",
    "performance": "Performance",
    "dailyAverage": "Daily Average:",
    "monthlyProjection": "Monthly Projection:",
    "animal": "animal",
    "animals": "animals",
    "noProducerData": "No producer data available",
    "topProducers": "Top 5 Producers",
    "producerTooltip": "Percentage represents the proportion of the {{count}} {{marbling}} × {{yg}} images that belong to each producer. The second number is the count for that producer."
  },
  "glossary": {
    "title": "Glossary",
    "averageWeight": {
      "title": "Average Weight",
      "content": "The average hot carcass weight of all animals processed in the selected time period. This value shows how heavy your cattle are at harvest and supports comparisons across seasons, genetics, and feeding programs."
    },
    "yieldGrade": {
      "title": "Yield Grade (YG)",
      "content": "Yield Grade is a U.S. system that predicts how much lean, boneless, saleable beef a carcass will produce. It ranges from YG 1 to YG 5: YG 1 is very lean with the highest meat yield, while YG 5 has more external fat and the lowest meat yield."
    },
    "yieldGradeCalculation": {
      "title": "How Yield Grade Is Calculated",
      "content": "Yield Grade is determined using four carcass measurements: (1) External fat thickness over the ribeye, (2) Ribeye area (muscle indicator), (3) Hot carcass weight, and (4) Estimated internal fat around the kidneys, pelvis, and heart (KPH). These factors are combined to estimate the percentage of retail beef yield."
    },
    "yieldGradeImportance": {
      "title": "Why Yield Grade Matters",
      "content": "Yield Grade shows how efficiently cattle convert weight into high-value meat. It helps identify: whether cattle are harvested too early or too late, whether fat cover is excessive or appropriate, how genetics and feeding influence lean yield, and opportunities to reduce waste and improve profitability."
    },
    "usdaMarbling": {
      "title": "USDA Marbling",
      "content": "USDA Marbling is a score representing the amount and distribution of intramuscular fat within the ribeye. More marbling generally results in better tenderness, juiciness, and flavour. This score drives U.S. quality grade classification."
    },
    "usdaQualityGrades": {
      "title": "USDA Quality Grades (Prime, Choice, Low Choice, Select)",
      "content": "These categories classify beef based mainly on marbling level: Prime has exceptional marbling and premium eating quality; Choice is high-quality beef with good marbling; Low Choice is the lower end of Choice but still acceptable; Select is leaner beef with less marbling and lower eating quality."
    },
    "usdaMarblingScore": {
      "title": "USDA Marbling Score (numeric scale)",
      "content": "A continuous numeric value measured by MEQ technology reflecting the level of intramuscular fat. Higher scores align with higher-quality categories such as Prime and Choice."
    },
    "carcass": {
      "title": "Carcass / Total Carcasses",
      "content": "A carcass is the processed body of the animal after dressing. \"Total Carcasses\" indicates the number of animals included in the selected period."
    },
    "volumePercent": {
      "title": "Volume %",
      "content": "The percentage of total carcasses that fall into a specific classification (such as a Yield Grade or Marbling level). This shows how your herd is distributed across quality and yield outcomes."
    },
    "imageGrid": {
      "title": "Image Grid (Images)",
      "content": "A visual display of real carcass photos for different combinations of Marbling and Yield Grade. These images help producers see how each classification appears in practice — fat cover, muscle area, and marbling patterns."
    }
  }
}
